var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0201 2.90625C8.71009 2.90625 6.02009 5.59625 6.02009 8.90625V11.7963C6.02009 12.4063 5.76009 13.3362 5.45009 13.8562L4.30009 15.7663C3.59009 16.9463 4.08009 18.2563 5.38009 18.6963C9.69009 20.1363 14.3401 20.1363 18.6501 18.6963C19.8601 18.2963 20.3901 16.8663 19.7301 15.7663L18.5801 13.8562C18.2801 13.3362 18.0201 12.4063 18.0201 11.7963V8.90625C18.0201 5.60625 15.3201 2.90625 12.0201 2.90625Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8699 3.1975C13.5599 3.1075 13.2399 3.0375 12.9099 2.9975C11.9499 2.8775 11.0299 2.9475 10.1699 3.1975C10.4599 2.4575 11.1799 1.9375 12.0199 1.9375C12.8599 1.9375 13.5799 2.4575 13.8699 3.1975Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.02 19.0625C15.02 20.7125 13.67 22.0625 12.02 22.0625C11.2 22.0625 10.44 21.7225 9.90002 21.1825C9.36002 20.6425 9.02002 19.8825 9.02002 19.0625",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellicon);
export default __webpack_public_path__ + "static/media/bellicon.2fec966a3f3dd6c6fa91bb1e601d7fe3.svg";
export { ForwardRef as ReactComponent };